<div class="bc-wrapup-panel" [attr.data-automation-id]="'bc-wrap-up-panel'">
  <h3 class="bc-panel-title">{{ titleTextKey | translate }}</h3>

  <form name="bcWrapupForm" class="bc-wrapup-form js-wrapup-form" (ngSubmit)="submitForm(wrapUps)" novalidate="novalidate">
    <div class="bc-wrapup-list" *ngFor="let wrapUp of wrapUps">
      <app-form-field [data]="wrapUp" #formComponent></app-form-field>
    </div>

    <div class="bc-errors" *ngIf="error">
      <div class="alert alert-danger">
        <p>{{ 'bcWrapupPanel.formError' | translate }}</p>
      </div>
    </div>

    <div class="bc-actions clearfix" *ngIf="!isClosed">
      <button type="submit"
              class="btn btn-dark js-save-wrap-up-btn"
              *ngIf="isEnded"
              (click)="setupValidation(true)"
              [disabled]="saveInProgress"
              [attr.data-automation-id]="'bc-wrap-up-submit'">
        <span>{{ 'bcWrapupPanel.saveBtn' | translate }}</span>
      </button>

      <button type="submit"
              class="btn btn-dark js-back-to-workitem-btn"
              *ngIf="!isEnded"
              (click)="setupValidation(false)"
              [attr.data-automation-id]="'bc-wrap-up-back-to-work=item'">
        <span>{{ backButtonTextKey | translate }}</span>
      </button>

      <div class="bc-action-text" *ngIf="isEnded && (saveCompleted || !requiredWrapUps)">
        <span>{{ 'bcWrapupPanel.autoCloseText' | translate }}</span>
      </div>
    </div>
  </form>
</div>
